/**
 * AT トップ スライダーカルーセル
 * 左右スライド、ボタン、ドット、スワイプ、オートスライド対応
 */
(function() {
  'use strict';

  var CAROUSEL_SELECTOR = '#at-carousel-area';
  var CONTROLS_SELECTOR = '.at-carousel-controls';
  var SECTION_SELECTOR = '#vidual-area';
  var TRACK_SELECTOR = '.at-carousel-track';
  var SLIDE_SELECTOR = '.at-carousel-slide';
  var AUTOPLAY_DELAY = 5000;

  function initCarousel() {
    var container = document.querySelector(CAROUSEL_SELECTOR);
    var controlsWrapper = document.querySelector(CONTROLS_SELECTOR);
    var section = document.querySelector(SECTION_SELECTOR);
    if (!container) return;

    var track = container.querySelector(TRACK_SELECTOR);
    var slides = container.querySelectorAll(SLIDE_SELECTOR);
    var slideCount = slides.length;

    if (slideCount === 0) return;

    var currentIndex = 0;
    var autoplayTimer = null;
    var isTransitioning = false;

    // レスポンシブ画像データ（Liquidから渡される）
    var slideData = window.atCarouselSlides || [];

    function goToSlide(index) {
      if (isTransitioning) return;
      isTransitioning = true;
      currentIndex = ((index % slideCount) + slideCount) % slideCount;
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      updateDots();
      updateContent(currentIndex);
      resetAutoplay();
      setTimeout(function() { isTransitioning = false; }, 500);
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    function updateDots() {
      var dots = (controlsWrapper || container).querySelectorAll('.at-carousel-dots button');
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex);
      });
    }

    function escapeHtml(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function updateContent(index) {
      var data = slideData[index];
      if (!data) return;

      var titleEl = document.getElementById('at-carousel-title');
      var descriptionEl = document.getElementById('at-carousel-description');
      var linkEl = document.getElementById('at-carousel-link');
      var logoEl = document.getElementById('at-carousel-logo');

      if (titleEl) {
        var titleRaw = (data.title && data.title.trim())
          ? data.title
          : (titleEl.dataset.defaultText || 'スライドタイトル');
        titleEl.textContent = titleRaw;
      }

      if (descriptionEl) {
        var raw = (data.description && data.description.trim())
          ? data.description
          : (descriptionEl.dataset.defaultText || '');
        var text = escapeHtml(raw).replace(/\n/g, '<br>');
        descriptionEl.innerHTML = text;
      }

      if (linkEl) {
        linkEl.href = (data.link && data.link.trim()) ? data.link : '#service';
      }

      if (logoEl) {
        logoEl.style.display = data.hideLogo ? 'none' : '';
      }
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(nextSlide, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      startAutoplay();
    }

    // 左右ボタン（controlsWrapper内を検索）
    var searchRoot = controlsWrapper || container;
    var prevBtn = searchRoot.querySelector('.at-carousel-arrow--prev');
    var nextBtn = searchRoot.querySelector('.at-carousel-arrow--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        prevSlide();
      });
      prevBtn.setAttribute('aria-label', '前のスライド');
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        nextSlide();
      });
      nextBtn.setAttribute('aria-label', '次のスライド');
    }

    // ドットクリック
    (controlsWrapper || container).querySelectorAll('.at-carousel-dots button').forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        goToSlide(i);
      });
      dot.setAttribute('aria-label', 'スライド ' + (i + 1) + ' / ' + slideCount);
    });

    // スワイプ対応（#vidual-areaで受信、slider-areaはz-index:-1で背面のため）
    var touchStartX = 0;
    var touchEndX = 0;
    var swipeTarget = section || container;

    if (swipeTarget) {
      swipeTarget.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      swipeTarget.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        var threshold = 50;

        if (Math.abs(diff) > threshold) {
          if (diff > 0) nextSlide();
          else prevSlide();
        }
      }, { passive: true });
    }

    // マウスホバーでオートスライド一時停止
    if (section) {
      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
    } else {
      container.addEventListener('mouseenter', stopAutoplay);
      container.addEventListener('mouseleave', startAutoplay);
    }

    // 初期表示
    updateDots();
    updateContent(0);
    startAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
  } else {
    initCarousel();
  }
})();
